import React from 'react';
import { Tag } from 'antd';
import { COLORS } from '../../pages/theme';


export const TagSelector = ({
    value, options,onChange,...item
}) => {
    return <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap'
    }}>
        {Array.isArray(options) && options.map((option) => {
            let _value=item.item_key?option[item.item_key]:option.value;
            let text=item.display_key?option[item.display_key]:option.text;

            return  <Tag
            className='hand-cursor'
            color={value==_value?COLORS.primary:null}
            key={_value}
            style={{marginRight:8,marginBottom:6}}
            checked={value==_value}
            onClick={checked => onChange(_value)}
          >
           {item.render ? option.render(text) : text}
          </Tag>
        })}
    </div>
}